import script from "./view-image-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./view-image-list.vue?vue&type=script&setup=true&lang=ts"

import "./view-image-list.vue?vue&type=style&index=0&id=13591c60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13591c60"]])

export default __exports__